import React, { FC } from 'react';
import { generatePath, useHistory } from 'react-router';
import { ROUTES } from '../../../constants/routes';
import { Cell, HeaderCell, Left, NoMatching, Row, RowsWrapper, Underlined, Wrapper } from './TableStyles';

type Props = {
  TicketsRows: any[];
};
const TicketsTable: FC<Props> = ({ TicketsRows }) => {
  const history = useHistory();
  const onClick = row => {
    const path = generatePath(ROUTES.PERMIT, {
      projectId: row.projectId,
      permitId: row.permit,
    });
    history.push(path);
  };

  return (
    <Wrapper>
      <Row>
        <HeaderCell>
          <Left>Project - Permit</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Ticket Number</Left>
        </HeaderCell>
        <HeaderCell>
          <Left>Status</Left>
        </HeaderCell>
      </Row>
      <RowsWrapper>
        {TicketsRows.length === 0 && <NoMatching>No matching records found</NoMatching>}
        {TicketsRows.length > 0 &&
          TicketsRows.map((ticket, index) => {
            return (
              <Row key={index}>
                <Cell>
                  <Left>
                    <Underlined onClick={e => onClick(ticket)}>{`${ticket.projectName} - ${ticket.permitName}`}</Underlined>
                  </Left>
                </Cell>
                <Cell>
                  <Left>{ticket.id}</Left>
                </Cell>
                <Cell>
                  <Left>{ticket.statusName}</Left>
                </Cell>
              </Row>
            );
          })}
      </RowsWrapper>
    </Wrapper>
  );
};

export default TicketsTable;
